import styled, { Device, Modal, Scale, Typography, breakpoints } from '@secretescapes/falcon';

export const HeaderContainer = styled('div')`
  position: sticky;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${Scale.xs} ${Scale.m} ${Scale.xs} ${Scale.xs};
  margin-bottom: ${Scale.xl};
  background-color: ${({ theme }) => theme.color.black};

  @media (min-width: ${breakpoints[Device.tablet]}) {
    background-color: ${({ theme }) => theme.color.white};
    padding: ${Scale.xl} 0 ${Scale.m};
  }

  @media (min-width: ${breakpoints[Device.desktop]}) {
    margin-bottom: ${Scale.xxl};
  }
`;

export const GridContainer = styled('div')`
  display: grid;
  grid-template-columns: auto;
  gap: ${Scale.l};

  @media (min-width: ${breakpoints[Device.tablet]}) {
    grid-template-columns: repeat(2, 1fr);
    gap: ${Scale.m};
  }

  @media (min-width: ${breakpoints[Device.desktop]}) {
    gap: ${Scale.l};
  }
`;

// We have these styles as important to enforce them, due to a bug DEV-74293:
// Styles were somehow being overwritten by those on the Modal component on very rare occasions
export const StyledModal = styled(Modal)`
  & {
    width: 100% !important;
    height: 100% !important;
    overflow-x: hidden !important;
    overflow-y: scroll !important;
    border-radius: 0 !important;
    background-color: ${({ theme }) => theme.color.white} !important;

    > div {
      width: 100% !important;
      height: 100% !important;
      border-radius: 0 !important;
    }
  }
`;

export const ModalContainer = styled('div')`
  box-sizing: border-box;
  align-self: center;
  padding: 0 0 ${Scale.l};
  margin: auto;

  @media (min-width: ${breakpoints[Device.tablet]}) {
    max-width: 1352px;
    padding: 0 ${Scale.l} ${Scale.l};
  }

  @media (min-width: ${breakpoints[Device.desktop]}) {
    max-width: 1400px;
    padding: 0 ${Scale.xxl} ${Scale.xxl};
  }
`;

export const ImageWrapper = styled('div')`
  aspect-ratio: 3 / 2;
  width: 100%;

  .grid__image {
    display: block;
  }
`;

export const StyledTypography = styled(Typography)`
  @media (max-width: ${breakpoints[Device.tablet]}) {
    padding: 0 ${Scale.m};
  }
`;

export const GridItemWrapper = styled('div')`
  text-align: left;
  cursor: pointer;

  @media (max-width: ${breakpoints[Device.tablet]}) {
    cursor: none;
    pointer-events: none;
  }
`;
